import { ReactComponent as DataElementIcon } from "@/assets/svgs/icon-data-element.svg";
import MultiLevelDropDown from "@/components/MultiLevelMenuDropDown/index";
import useModal from "@/hooks/use-modal/index";
import usePackages from '@/hooks/use-packages/index.js';
import { useParams } from "@/lib/router-dom/index.js";
import MultiClamp from "react-multi-clamp";
import PackageConfirmDeleteModal from "./package-confirm-delete-modal.jsx";

const PackageReceivingDataElementCard = ({ currentPackage, dataElement, reload }) => {
	/*=================================================
		Handle  remove receiving data element card
	/================================================*/

	// const params = useParams();
	const { eclipId } = useParams();
	const { addRemoveDataElements } = usePackages()

	const { visible: confirmDeleteModalVisible, hide: hideConfirmDeleteModal, show: showConfirmDeleteModal } = useModal();

	const packageMenu =
		[
			{
				label: "Delete Data Element",
				labelColor: "#A72E12",
				onClick: (e) => {
					e.stopPropagation();
					showConfirmDeleteModal()
				},
			}
		]

		async function handleConfirmDeleteDataElement() {
			hideConfirmDeleteModal();
			const submitDataElement = [{
				dataElementId: dataElement.dataElementId,
				type: dataElement.type,
				parent_node_id: dataElement.parent_node_id,
				parent_node_type: dataElement.parent_node_type
			}]

			await addRemoveDataElements(eclipId, "REMOVE", submitDataElement);
			reload();
		}

	return (
		<>
			<div className="package-receiving-data-card">
				<div className="package-receiving-data-card__header">
					<DataElementIcon />
					<div className="package-receiving-data-card__header__name">
						<MultiClamp clamp={2}>
							{dataElement?.name}
						</MultiClamp>
					</div>
					{
						(!currentPackage.sent || (currentPackage.sent && dataElement.isDraft)) && (
							<div className='package-receiving-data-card__menu'>
								<MultiLevelDropDown
									menuList={packageMenu}
								/>
							</div>
						)
					}
				</div>
				<div className="package-receiving-data-card__content"> You will be receiving this document</div>
			</div>

			<PackageConfirmDeleteModal
				visible={confirmDeleteModalVisible}
				title="Remove Data Element"
				text={`Are you sure want to delete ${dataElement.elementName} Data Element?`}
				close={hideConfirmDeleteModal}
				submit={handleConfirmDeleteDataElement}
			/>

		</>

	)
}

export default PackageReceivingDataElementCard
